
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import {connect} from 'react-redux'
import {modalTypes} from 'redux/modules/ui/modal'
import {closeModal} from 'redux/modules/ui/modal/actions'
import Overlay from 'components/Overlay'
import EditProfileView from 'modals/EditProfileView'
import IntegrationAddView from 'modals/IntegrationAddView'
import IntegrationUploadView from 'modals/IntegrationUploadView'
import UserEditView from 'modals/UserEditView'
import UserAddView from 'modals/UserAddView'
import SiteAddView from 'modals/SiteAddView'
import ReportAddModal from 'modals/ReportAddModal'
import ReportDeleteConfirm from 'modals/ReportDeleteConfirm'
import ChannelSelectorModal from 'modals/ChannelSelectorModal'
import SiteDeleteConfirm from 'modals/SiteDeleteConfirm'
import PaymentDetailsModal from 'modals/PaymentDetailsModal'
import CancelSubscriptionConfirm from 'modals/CancelSubscriptionConfirm'
import UpdateSubscriptionConfirm from 'modals/UpdateSubscriptionConfirm'
import IntegrationsNewSpreadsheet from 'modals/IntegrationsNewSpreadsheet'
import IntegrationsNewManualInput from 'modals/IntegrationsNewManualInput'
import IntegrationsNewCriteo from 'modals/IntegrationsNewCriteo'
import HelpView from 'modals/HelpView'
import NotifyView from 'modals/NotifyView'
import {CSSTransitionGroup} from 'react-transition-group'
import classnames from 'classnames'

const {
  USER_PROFILE_EDIT,
  USER_EDIT,
  USER_ADD,
  SITE_ADD,
  INTEGRATION_ADD,
  INTEGRATION_UPLOAD,
  HELP_SHOW,
  NOTIFY_SHOW,
  REPORT_ADD,
  REPORT_DELETE_CONFIRM,
  CHANNEL_SELECTOR,
  PAYMENT_DETAILS,
  SITE_DELETE_CONFIRM,
  PAYMENT_CANCEL_SUBSCRIPTION_CONFIRM,
  PAYMENT_UPDATE_SUBSCRIPTION_PLAN_CONFIRM,
  INTEGRATIONS_NEW_SPREADSHEET,
  INTEGRATIONS_NEW_MANUAL_INPUT,
  INTEGRATIONS_NEW_CRITEO
} = modalTypes

const MODAL_COMPONENTS = {
  [USER_PROFILE_EDIT]: EditProfileView,
  [USER_EDIT]: UserEditView,
  [USER_ADD]: UserAddView,
  [SITE_ADD]: SiteAddView,
  [INTEGRATION_ADD]: IntegrationAddView,
  [INTEGRATION_UPLOAD]: IntegrationUploadView,
  [HELP_SHOW]: HelpView,
  [NOTIFY_SHOW]: NotifyView,
  [REPORT_ADD]: ReportAddModal,
  [REPORT_DELETE_CONFIRM]: ReportDeleteConfirm,
  [CHANNEL_SELECTOR]: ChannelSelectorModal,
  [PAYMENT_DETAILS]: PaymentDetailsModal,
  [SITE_DELETE_CONFIRM]: SiteDeleteConfirm,
  [PAYMENT_CANCEL_SUBSCRIPTION_CONFIRM]: CancelSubscriptionConfirm,
  [PAYMENT_UPDATE_SUBSCRIPTION_PLAN_CONFIRM]: UpdateSubscriptionConfirm,
  [INTEGRATIONS_NEW_SPREADSHEET]: IntegrationsNewSpreadsheet,
  [INTEGRATIONS_NEW_MANUAL_INPUT]: IntegrationsNewManualInput,
  [INTEGRATIONS_NEW_CRITEO]: IntegrationsNewCriteo
}

class Modal extends React.Component {
  static propTypes = {
    modalType: PropTypes.string,
    modalProps: PropTypes.object,
    closeModal: PropTypes.func,
    animationDuration: PropTypes.number
  }

  static defaultProps = {
    animationDuration: 200
  }

  constructor(props) {
    super(props)
    this.state = {
      isClosing: false
    }
  }

  componentWillReceiveProps(nextProps) {
    const {modalType} = this.props
    if (modalType && nextProps.modalType === null) {
      this.closeModal()
    }
  }

  render() {
    const {modalType, closeModal} = this.props
    const {isClosing} = this.state
    const classNames = classnames('modal', {
      'is-visible': modalType || isClosing
    })
    return (
      <div className={classNames} onClick={closeModal}>
        {this.renderOverlay()}
      </div>
    )
  }

  renderOverlay() {
    const {modalType, animationDuration} = this.props

    return (
      <Overlay animationDuration={animationDuration} visible={!!modalType}>
        <CSSTransitionGroup
          transitionName='modal'
          transitionEnterTimeout={animationDuration}
          transitionLeaveTimeout={animationDuration}
        >
          {this.renderModal()}
        </CSSTransitionGroup>
      </Overlay>
    )
  }

  renderModal() {
    const {modalType, modalProps, closeModal} = this.props
    const ModalComponent = MODAL_COMPONENTS[modalType] || null

    if (modalType === null || !ModalComponent) return null

    return <ModalComponent closeModal={closeModal} {...modalProps} />
  }

  closeModal() {
    const {animationDuration} = this.props
    this.setState({'isClosing': true})
    setTimeout(() => this.setState({'isClosing': false}), animationDuration)
  }
}

const mapStateToProps = (state, props) => {
  return {
    ...state.ui.modal
  }
}

export default connect(mapStateToProps, {
  closeModal
})(Modal)



// WEBPACK FOOTER //
// ./client/containers/Modal/index.js